import {
  useState,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { ModalContext } from "../utils/constants";
import ModalRoot from "../components/ModalRoot/ModalRoot";

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({ open: false });
  const lockRef = useRef(false);
  const scrollYRef = useRef(0);

  const openModal = useCallback((type, content = null, props = {}) => {
    try {
      if (lockRef.current) return;
      
      // Проверяем валидность типа
      if (!type || typeof type !== 'string') {
        console.error('Modal type is required and must be a string');
        return;
      }
      
      lockRef.current = true;
      scrollYRef.current = window.scrollY;
      
      setModal((prev) => {
        if (prev.open) return prev;
        return { open: true, type, content, props };
      });
      
      // Сбрасываем lock через анимацию
      setTimeout(() => {
        lockRef.current = false;
      }, 300);
    } catch (error) {
      console.error('Error opening modal:', error);
      lockRef.current = false;
    }
  }, []);

  const closeModal = useCallback(() => {
    try {
      setModal({ open: false, type: null, content: null, props: {} });
      lockRef.current = false;
      // Убираем дублирование восстановления скролла - это делает useEffect
    } catch (error) {
      console.error('Error closing modal:', error);
      // Принудительно сбрасываем состояние
      setModal({ open: false });
      lockRef.current = false;
    }
  }, []);

  useEffect(() => {
    if (modal.open) {
      // Сохраняем текущую позицию скролла
      scrollYRef.current = window.scrollY;
      
      // Блокируем скролл страницы
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollYRef.current}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // Скрываем кнопку "наверх"
      const scrollToTop = document.getElementById('scrollToTop');
      if (scrollToTop) scrollToTop.style.display = 'none';
      
      return () => {
        // Восстанавливаем скролл страницы
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollYRef.current);
        
        // Показываем кнопку "наверх"
        if (scrollToTop) scrollToTop.style.display = 'block';
      };
    }
  }, [modal.open]);

  return (
    <ModalContext.Provider value={{ modal, openModal, closeModal }}>
      {children}
      <ModalRoot />
    </ModalContext.Provider>
  );
};
